import gql from 'graphql-tag'
export default gql`mutation createTypeOfWorkMutation($typeOfWork: BaseTypeOfWork!) {
  createTypeOfWork(typeOfWork: $typeOfWork) {
    code
    description
    maxChloride
    minPercentageFine
    id
  }
}`